import React from 'react';
import LSM from '../../../modules/cache/tool-local-storage';
import { LOCAL_STORAGE_KEYS } from '../../../modules/cache/local-storage.constant';
import _ from 'lodash';
import { ITEM_TYPE, MenuDish } from '../../../models/menu-dish.entity';
import { TaxGroup } from '../../../models/tax-group.entity';
import i18n from '../../../i18n';
import { apiManage_rbp } from '../../../request';
import { PatchDishesParams } from '../../../request/api/rbp/menu';
import GlobalNotification from '../../../component/common/snackbar';
import { Box, Grid } from '@mui/material';
import CommonInput from '../../../component/form/common-input.component';
import { FormFieldCell } from '../../../component/form/form-field-cell.component';
import BASE_CHECK_TYPE from '../../../constants/regular.constant';

/**
 * 额外费用菜品详情
 */
class ExtraCostDishDetail extends React.Component<Props, State> {
    // 从缓存中拿服务器地址
    public SERVER_URL = LSM.get(LOCAL_STORAGE_KEYS.SERVER_URL);

    // 是否意大利国家
    public isItaly = LSM.get(LOCAL_STORAGE_KEYS.RBP_RESTAURANT_COUNTRY) === 'Italy';
    // 修改菜名2
    public editDishName2 = false;
    public state: State = {
        // 详情
        detail: _.cloneDeep(this.props.detail) || {},
        // 菜品图片
        avatarUrl: '',
        // 大图
        avatarUrlMax: '',
        // 加载中
        isLoading: false,
    };

    /**
     * 供父级弹窗「保存」调用（与 Card 内保存按钮同源）
     */
    public submitDish = async () => {
        await this.onSave();
    };

    // *********************
    // Life Cycle Function
    // *********************

    componentDidMount() {
        this.init();
    }

    // *********************
    // Default Function
    // *********************

    /**
     * 初始化
     */
    init() {
        const { detail } = this.state;
        detail.item_name1 = detail.item_name1 ?? 'Unnamed';
        detail.price_1 = detail.price_1 ?? 0;
        detail.takeout_price_1 = detail.takeout_price_1 ?? 0;
        detail.item_type = detail.item_id ? detail.item_type ?? 0 : 0;
        detail.print_class = detail.print_class || -1;
        detail.tax_group = detail.tax_group || -1;
        detail.discount_itemizer = detail.discount_itemizer ?? 9;
        if (!detail.item_id) {
            detail.item_name2 = detail.item_name2 ?? 'Unnamed';
        }
        if (this.props.variant === 'park-project-binding') {
            const mt = detail.menu_time;
            detail.menu_time =
                mt === null || mt === undefined || mt === ''
                    ? 0
                    : typeof mt === 'number'
                        ? mt
                        : Number(mt) || 0;
        }
        this.setState({
            detail,
            avatarUrl: detail.item_id ? `${this.SERVER_URL}/${detail.item_id}_s.jpg?randomId=${Math.random()}` : '',
            avatarUrlMax: detail.item_id ? `${this.SERVER_URL}/${detail.item_id}.jpg?randomId=${Math.random()}` : '',
        });
    }

    /**
     * 保存
     */
    async onSave() {
        const { detail } = this.state;
        // 菜品名称必填
        if (!_.trim(detail.item_name1)) {
            return;
        }
        // 意大利--菜品名称
        if (this.isItaly && !(BASE_CHECK_TYPE.dishNameAndNlu2.regular.test(detail.item_name1 ?? ''))) {
            GlobalNotification.error(i18n.t('input_rule_text_enter_dish_name_and_nlu_regular2'));
            return;
        }
        let result;
        const isPark = this.props.variant === 'park-project-binding';
        if (detail.item_id) {
            const params = [{
                item_id: detail.item_id,
                item_name1: detail.item_name1,
                item_name2: detail.item_name2,
                item_type: detail.item_type,
                price_1: detail.price_1,
                takeout_price_1: detail.takeout_price_1,
                tax_group: detail.tax_group,
                class_id: [9, null, undefined].includes(detail.discount_itemizer) ? 6 : 3,
                print_class: detail.print_class,
                ...(isPark ? { menu_time: detail.menu_time } : {}),
            }];

            result = await apiManage_rbp.patch_dishes(params);
        } else {
            detail.class_id = [9, null, undefined].includes(detail.discount_itemizer) ? 6 : 3;
            detail.item_name2 = detail.item_name2 || detail.item_name1;
            delete detail.discount_itemizer;
            const postBody = { ...(detail as PatchDishesParams) };
            if (!isPark) {
                delete postBody.menu_time;
            }
            result = await apiManage_rbp.post_dishes(postBody);
            detail.item_id = result.insertId;
        }
        if (!_.get(result, 'error')) {
            await this.props.getMenuData();
            GlobalNotification.success(i18n.t('global_text_operate_success'));
            this.setState({
                detail,
                avatarFile: undefined,
            });
            this.props.handleClickBack();
        } else {
            GlobalNotification.error(i18n.t('global_text_operate_failure'));
        }
    }

    /**
     * 上传菜品图片
     */
    async updateImage(dishId: number) {
        let result = true;
        const { avatarFile } = this.state;
        if (avatarFile) {
            const imageResult = await apiManage_rbp.post_dishes_image(`${dishId}_s,${dishId}`, avatarFile);
            if (_.get(imageResult, 'error')) {
                result = false;
            }
        }
        return result;
    }

    /**
     * 表单回调
     */
    onChange(value: number | string | string[], key: string) {
        const { detail } = this.state;
        let newValue = value;
        const propDetail = this.props.detail;
        if (key === 'price_1') {
            if (value && Number(value) < 0) {
                newValue = 0;
            } else if (value) {
                newValue = Number(Number(value).toFixed(2));
            }
        }
        if (key === 'menu_time') {
            const n = Number(value);
            newValue = Number.isFinite(n) && n >= 0 ? Math.floor(n) : 0;
        }
        if (key === 'item_name2' && !propDetail.item_id) {
            this.editDishName2 = !!newValue;
        }
        if (!propDetail.item_id && key === 'item_name1') {
            !this.editDishName2 && _.set(detail, 'item_name2', value);
        }
        _.set(detail, key, newValue);
        this.setState({
            detail,
        });
    }

    /**
     * 删除菜品图片
     */
    async deleteImage() {
        const { detail, avatarFile } = this.state;
        if (detail.item_id) {
            if (avatarFile) {
                this.setState({
                    avatarUrl: '',
                    avatarUrlMax: '',
                    avatarFile: undefined,
                });
            }
        } else {
            this.setState({
                avatarUrl: '',
                avatarUrlMax: '',
                avatarFile: undefined,
            });
        }
    }

    private renderFormFields() {
        const { detail } = this.state;
        const taxGroup = this.props.taxGroup.map((item) => ({
            label: item.tax_group_name || '',
            value: item.tax_group_id || 0,
        }));
        taxGroup.unshift({
            value: -1,
            label: i18n.t('menu_and_dishes_page_not_specified'),
        });
        const printGroup = this.props.printGroup.map((item) => ({
            label: item.print_class_name || '',
            value: item.print_class_id || 0,
        }));
        const showMenuTime = this.props.variant === 'park-project-binding';

        const formArr = [
            {
                key: 'item_name1',
                label: i18n.t('global_text_name'),
                regularType: this.isItaly ? 'dishNameAndNlu2' : 'required',
                require: true,
            },
            {
                key: 'item_name2',
                label: `${i18n.t('global_text_name')}2`,
            },
            ...(showMenuTime
                ? [
                    {
                        key: 'menu_time' as const,
                        label: i18n.t('extra_cost_dish_table_menu_time') + '(min)',
                        type: 'number' as const,
                    },
                ]
                : []),
            {
                key: 'item_type',
                label: i18n.t('menu_and_dishes_page_dish_type'),
                select: true,
                items: ITEM_TYPE,
                require: true,
                regularType: 'required',
            },
            {
                key: 'price_1',
                label: i18n.t('menu_and_dishes_page_price'),
                type: 'number' as const,
            },
            {
                key: 'takeout_price_1',
                label: i18n.t('menu_and_dishes_page_takeout_price'),
                type: 'number' as const,
            },
            {
                key: 'tax_group',
                label: i18n.t('tax_group_page_label'),
                type: 'select' as const,
                select: true,
                items: taxGroup,
            },
            {
                key: 'discount_itemizer',
                label: i18n.t('menu_and_dishes_page_menu_dish_has_discount'),
                type: 'select' as const,
                select: true,
                items: [
                    { label: i18n.t('menu_and_dishes_page_has_discount'), value: 9 },
                    { label: i18n.t('menu_and_dishes_page_has_not_discount'), value: 0 },
                ],
            },
            {
                key: 'print_class',
                label: i18n.t('menu_and_dishes_page_print_class'),
                type: 'select' as const,
                select: true,
                items: [
                    { value: -1, label: i18n.t('print_setting_page_none0') },
                    ...printGroup,
                ],
            },
        ];

        return (
            <>
                {formArr.map((item) => (
                    <Grid key={item.key} item xs={12} md={4}>
                        <FormFieldCell label={item.label}>
                            <CommonInput
                                type={item.type}
                                select={item.select}
                                items={item.items || []}
                                required={item.require}
                                regularType={item.regularType}
                                variant="outlined"
                                fullWidth
                                hiddenLabel
                                value={_.get(detail, item.key, '') ?? ''}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    this.onChange(event.target.value, item.key);
                                }}
                            />
                        </FormFieldCell>
                    </Grid>
                ))}
            </>
        );
    }

    render() {
        return (
            <Box sx={{ pt: 1 }}>
                <Grid container spacing={2}>
                    {this.renderFormFields()}
                </Grid>
            </Box>
        );
    }
}

export default ExtraCostDishDetail;

type Props = {
    detail: MenuDish;
    handleClickBack: () => void;
    getMenuData: () => Promise<void>;
    taxGroup: TaxGroup[];
    printGroup: any[];
    /** 默认额外费用；游乐园项目绑定传 `park-project-binding` 以展示/保存「时长」 */
    variant?: 'extra-cost' | 'park-project-binding';
};
type State = {
    detail: MenuDish;
    avatarUrl: string;
    avatarUrlMax: string;
    avatarFile?: File;
    isLoading: boolean;
};
